import styled from 'styled-components';

export const ResultsWrapper = styled.div`
  width: 100%;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding-top: 12px;

    .carRentalList__sortingTabs {
      padding: 0px 16px;
    }
    .scroll-to-top-button {
      bottom: 80px;
      right: 10px;
      width: 45px;
      height: 45px;
    }
  }
`;

export const ResultsSkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  width: 100%;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 0px 16px;
    max-width: 468px;
    margin: 0px auto;
  }
`;

export const BasketErrorText = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.black};
`;

export const NotFoundWrapper = styled.div`
  width: 100%;

  padding: 100px 0;
  display: flex;
  margin: 0 auto;
  flex-direction: column;

  align-items: center;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    padding: 50px 0;
  }
`;

export const ListingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
